import productApi from "@/api/api-product";
import deptApi from "@/api/api-dept";
import salesApi from "@/api/api-sales";
import stockApi from "@/api/api-stock";
import earlyWarningSetApi from "@/api/api-earlyWarningSet";
import goodsRequestApi from "@/api/api-goodsRequest";
import appApi from "@/api/api-app";

const common = {
  // js正则实现数字格式化,每三位加逗号
  getNumberFormatter(value) {
    if (!value) return '0';
    /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
    var intPart = Number(value) | 0; //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    var floatPart = ""; // ".0" 预定义小数部分
    var value2Array = value.split(".");

    //=2表示数据有小数位
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString().substr(0, 1); //拿到小数部分
      if (floatPart == '0' || floatPart == 0) { //补0,实际上用不着
        return intPartFormat // parseFloat(intPartFormat + "." + floatPart) // + '0';
      } else {
        return (intPartFormat + "." + floatPart) //parseFloat(intPartFormat + "." + floatPart);
      }
    } else {
      return intPartFormat // + floatPart;
    }
  },
  /**
   * 时间格式转换
   * @param {*} data
   */
  getDay(date) {
    let myDate = new Date(date)
    var days = myDate.getDay();
    switch (days) {
      case 1:
        days = '一';
        break;
      case 2:
        days = '二';
        break;
      case 3:
        days = '三';
        break;
      case 4:
        days = '四';
        break;
      case 5:
        days = '五';
        break;
      case 6:
        days = '六';
        break;
      case 0:
        days = '日';
        break;
    }
    return days;
  },
  getStartTime (date) {
    let d = new Date(date)
    let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + '00:00:00'
    return str
  },
  getEndTime (date) {
    let d = new Date(date)
    let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + '23:59:59'
    return str
  },
  getDate(date) {
    let d = new Date(date)
    return d.getDate()
  },
  getMonthDate(date) {
    let d = new Date(date)
    return (d.getMonth() + 1) + '#' + d.getDate()
  },
  getDateDetail() {
    var d = new Date();
    return d.getFullYear() + '' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate()) + (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) + (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) + (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds())

  },
  getMonth(date) {
    let d = new Date(date)
    let str = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' // + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    return str
  },
  getMonthDay(date) {
    let d = new Date(date)
    let str = (d.getMonth() + 1) + '月'+d.getDate() + '日'
    return str
  },
  getMonthDetail(date) {
    let d = new Date(date)
    let str = d.getFullYear() + '-' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-01'
    return str
  },
  getDateTime(date) {
    let d = new Date(date)
    let str = d.getFullYear() + '-' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate())
    return str
  },
  getTime(date) {
    let d = new Date(date)
    let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() // + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    return str
  },
  getTimeDetail(date) {
    let d = new Date(date);
    let str = (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) + ':' + (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) + ':' + (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds());
    return str;
  },
  // 保留1位小数
  formatDecimal(value) {
    if (!value) return '0';
    /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
    var intPart = Number(value) | 0; //获取整数部分
    var floatPart = ""; // ".0" 预定义小数部分
    var value2Array = value.split(".");
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString().substr(0, 1); //拿到小数部分
      if (floatPart == '0' || floatPart == 0) { //补0,实际上用不着
        return intPart // parseFloat(intPartFormat + "." + floatPart) // + '0';
      } else {
        return (intPart + "." + floatPart) //parseFloat(intPartFormat + "." + floatPart);
      }
    } else {
      return intPart
    }
  },
  // 保留两位小数
  toDecimal2(x) {
    var f = parseFloat(x)
    if (isNaN(f)) {
      return false
    }
    var f = Math.round(x * 100) / 100
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      return s
    }
    // if (rs < 0) {
    //   rs = s.length
    //   s += '.'
    // }
    // while (s.length <= rs + 2) {
    //     s += '0'
    // }
    return parseFloat(s)
  },
  // 保留一位小数
  toDecimal1(x) {
    var f = parseFloat(x)
    if (isNaN(f)) {
      return false
    }
    var f = Math.round(x * 10) / 10
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      return s
    }
    return parseFloat(s)
  },
  
  getNewDate(data) {
    let str = null
    if (typeof (data) !== 'undefined' && data != null) {
      str = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data)
    }
    return str
  },

  compareDateToNow(date) {
    let result = new Date(date.replace(/\-/g, '\/')) < new Date() - 86400000
    return result
  },
  getLastDate(n = 1){
    var time = (new Date).getTime() +  n * 24 * 60 * 60 * 1000;
    var yesterday = new Date(time);
    let str = yesterday.getFullYear() + "-" + (yesterday.getMonth() >= 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? yesterday.getDate() : ("0" + yesterday.getDate()));
    return str
  },
  getLastDay(n = 1){
    var time = (new Date).getTime() +  n * 24 * 60 * 60 * 1000;
    var yesterday = new Date(time);
    let str = (yesterday.getMonth() >= 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? yesterday.getDate() : ("0" + yesterday.getDate()));
    return str
  },
  // 获取前一天
  getPerDate(n = 1) {
    var time = (new Date).getTime() - n * 24 * 60 * 60 * 1000;
    var yesterday = new Date(time);
    var month = yesterday.getMonth();
    var day = yesterday.getDate();
    yesterday = yesterday.getFullYear() + "-" + (yesterday.getMonth() >= 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? yesterday.getDate() : ("0" + yesterday.getDate()));
    return yesterday
  },
  // 获取指定日期前n天
  getCPerDate(date, n = 1) {
    var time = new Date(date).getTime() - n * 24 * 60 * 60 * 1000;
    var yesterday = new Date(time);
    var month = yesterday.getMonth();
    var day = yesterday.getDate();
    yesterday = yesterday.getFullYear() + "-" + (yesterday.getMonth() >= 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? yesterday.getDate() : ("0" + yesterday.getDate()));
    return yesterday
  },
  // 获取当前日期前12个月
  getCPerMonth() {
    var dataArr = [];
    var data = new Date();
    var year = data.getFullYear();
    // data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
    for (var i = 0; i < 12; i++) {
      data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
      var m = data.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      dataArr.push(data.getFullYear() + "-" + (m) + "-01")
    }
    console.log(dataArr);
    return dataArr
  },
  datedifference(sDate1, sDate2) { //sDate1和sDate2是2006-12-18格式
    var dateSpan,
      tempDate,
      iDays;
    sDate1 = Date.parse(sDate1);
    sDate2 = Date.parse(sDate2);
    dateSpan = sDate2 - sDate1;
    dateSpan = Math.abs(dateSpan);
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
    return iDays
  },
  formatDecimal1(value) {
    if (!value) return '0'
    /* 原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正 */
    var intPart = Number(value) | 0 // 获取整数部分
    var floatPart = '' // ".0" 预定义小数部分
    var value2Array = value.split('.')
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString().substr(0, 1) // 拿到小数部分
      if (floatPart == '0' || floatPart == 0) { // 补0,实际上用不着
        return intPart + '.0' // parseFloat(intPartFormat + "." + floatPart) // + '0';
      } else {
        return intPart + '.' + floatPart // parseFloat(intPartFormat + "." + floatPart);
      }
    } else {
      return intPart + '.0'
    }
  },
  // 保留2位小数（不补零）
  formatDecimal2(value) {
    if (!value) return '0'
    /* 原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正 */
    var intPart = Number(value) | 0 // 获取整数部分
    var floatPart = '' // ".0" 预定义小数部分
    var value2Array = value.split('.')
    if (value2Array.length == 2) {
      if (value2Array[1].toString().substr(0, 1) == '0' || value2Array[1].toString().substr(0, 1) == 0 || value2Array[1].toString().substr(0, 2) == '00' || value2Array[1].toString().substr(0, 2) == 0) {
        return intPart + '.00'
      } else if (value2Array[1].toString().length == 1) {
        return intPart + '.' + value2Array[1] + '0' // parseFloat(intPartFormat + "." + floatPart);
      } else {
        floatPart = value2Array[1].toString().substr(0, 2) // 拿到小数部分
        return intPart + '.' + floatPart
      }
    } else {
      return intPart + '.00'
    }
  },
  // 加
  floatAdd(arg1, arg2) {
    var r1, r2, m
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
  },

  // 减
  floatSub(arg1, arg2) {
    var r1, r2, m, n
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },

  // 乘
  floatMul(arg1, arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {}
    try {
      m += s2.split('.')[1].length
    } catch (e) {}
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
  },

  // 除
  floatDiv(arg1, arg2) {
    var t1 = 0,
      t2 = 0,
      r1, r2
    try {
      t1 = arg1.toString().split('.')[1].length
    } catch (e) {}
    try {
      t2 = arg2.toString().split('.')[1].length
    } catch (e) {}

    r1 = Number(arg1.toString().replace('.', ''))

    r2 = Number(arg2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
  },

  // 根据中类小类获取商品分类列表
  // TypeFlag 0小类 1中类
  // TypeId 中类id,查询中类下小类列表(可不传)
  getProductTypeListByFLag(data) {
    return new Promise((resolve, reject) => {
      productApi
        .getProductTypeListByFLag(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // 获取区域
  getDeptArea() {
    return new Promise((resolve, reject) => {
      deptApi
        .getDeptArea()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 获取部门
  getDept(data) {
    return new Promise((resolve, reject) => {
      deptApi
        .getDept(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 获取门店概览
  getDeptFact (id) {
    return new Promise((resolve, reject) => {
      deptApi
        .getDeptFact(id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 修改门店概览
  setDeptFact (data) {
    return new Promise((resolve, reject) => {
      deptApi
        .setDeptFact(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },//分类汇总
  getStockSubtotal (data) {
    return new Promise((resolve, reject) => {
      stockApi
        .getStockSubtotal(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分类月明细
  getStockTypeMonthLy (data) {
    return new Promise((resolve, reject) => {
      stockApi
        .getStockTypeMonthLy(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 预警详情
  getEarlyWarningSet () {
    return new Promise((resolve, reject) => {
      earlyWarningSetApi
        .getEarlyWarningSet()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 新增、编辑预警
  earlyWarningSet (data) {
    return new Promise((resolve, reject) => {
      earlyWarningSetApi
        .earlyWarningSet(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 实时预警
  getSalesWarning (data) {
    return new Promise((resolve, reject) => {
      salesApi
        .getSalesWarning(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // 要货
  setGoodsRequest(data){
    return new Promise((resolve, reject) => {
      goodsRequestApi
        .setGoodsRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 判断是否已经存在要货单
  getGoodsRequest(data){
    return new Promise((resolve, reject) => {
      goodsRequestApi
        .getGoodsRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 报货列表
  getProductTypeDetail(data){
    return new Promise((resolve, reject) => {
      stockApi
        .getProductTypeDetail(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 报货列表
  getStockProductTypeRequestDetail(data){
    return new Promise((resolve, reject) => {
      stockApi
        .getStockProductTypeRequestDetail(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 报货分类汇总
  getStockRequestSum(data){
    return new Promise((resolve, reject) => {
      stockApi
        .getStockRequestSum(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
   // 获取模板列表
   getGoodsRequestTemplate(data){
    return new Promise((resolve, reject) => {
      goodsRequestApi
        .getGoodsRequestTemplate(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 获取天气
  getWeather(){
    return new Promise((resolve, reject) => {
      appApi
        .getWeather()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 价格区间设置默认值
  domains: "3,5,7,9,11,13,15,17,19,21,25",
  domainsList: [{
      value: 3,
      key: 1
    },
    {
      value: 5,
      key: 2
    },
    {
      value: 7,
      key: 3
    },
    {
      value: 9,
      key: 4
    },
    {
      value: 11,
      key: 5
    },
    {
      value: 13,
      key: 6
    },
    {
      value: 15,
      key: 7
    },
    {
      value: 17,
      key: 8
    },
    {
      value: 19,
      key: 9
    },
    {
      value: 21,
      key: 10
    },
    {
      value: 25,
      key: 11
    }
  ],
  // 实时预警详情
  tHeader: ['序号', '门店名称', '当前营业额', '对比营业额', '相差营业额', '百分比'],
  filterVal: ['index', 'deptName', 'money', 'moneyLast', 'moneyBalance', 'percent'],
  // 过期报废占比详情
  typeReturnTHeader:['序号','类别','金额','占比'],
  typeReturnFilterVal:['index', 'productTypeName','money','percent'],
  // 毛利占比详情
  profitTHeader:['序号','类别','毛利','占比'],
  profitFilterVal:['index', 'productTypeName','money','percent'],
   // 毛利占比详情
   productTypeTHeader:['序号','类别','金额','分类占比'],
   productTypeFilterVal:['index', 'productTypeName','money','percent'],
  // 门店报货
  stockTHeader:['序号', '分类名称','ABC','编码','产品名称','单价','已报货','帐存','期初','工厂入库','调拨入库','完工','外购','调拨','退货报废','销售','5点后','占比','末笔时间'],
  stockFilterVal:['index', 'productTypeName','abc','procuctCode','productName','price','haveRequestNum','accountCheckNum','openingBalance','factoryNum','affirmNum','shopFinishNum','shopOutSourcingNum','shopMoveOutNum','shopReturnNum','salesNum','salesNumFive','salesNumFivePer','lastSalesTime'],

  // 时段销售
  saleTHeader:['序号', '编码','产品名称','ABC','6点','6点半','7点','7点半','8点','8点半','9点','9点半','10点','10点半','11点','11点半','12点','12点半','13点','13点半','14点','14点半','15点','15点半','16点','16点半','17点','17点半','18点','18点半','19点','19点半','20点','20点半','21点','21点半','22点','22点半','23点','23点半','24点'],
  saleFilterVal:['index', 'productCode','productName','sumABC','6','6&5','7','7&5','8','8&5','9','9&5','10','10&5','11','11&5','12&5','12&5','13','13&5','14','14&5','15','15&5','16','16&5','17','17&5','18','18&5','19','19&5','20','20&5','21','21&5','22','22&5','23','23&5','24'],
  // 时段库存
  reserveTHeader:['序号','编码','产品名称', 'ABC','6点','6点半','7点','7点半','8点','8点半','9点','9点半','10点','10点半','11点','11点半','12点','12点半','13点','13点半','14点','14点半','15点','15点半','16点','16点半','17点','17点半','18点','18点半','19点','19点半','20点','20点半','21点','21点半','22点','22点半','23点','23点半','24点'],
  reserveFilterVal:['index','procuctCode','productName', 'sumABC','6','6&5','7','7&5','8','8&5','9','9&5','10','10&5','11','11&5','12&5','12&5','13','13&5','14','14&5','15','15&5','16','16&5','17','17&5','18','18&5','19','19&5','20','20&5','21','21&5','22','22&5','23','23&5','24'],
  // 菜单
  menuOtherRouter:[{
      key: 'Intelligent.DataBrain',
      path: '/dataBrain',
      name: 'dataBrain',
      component: 'main/dataBrain',
      meta: {
        title: '数据大脑'
      }
    }],
  menuMainRouter: [
    {
      key: 'Intelligent.ProductABC',
      path: 'productABC',
      name: 'productABC',
      component: 'main/productABC',
      meta: {
        title: '商品ABC'
      }
    },
    {
      key: 'Intelligent.DispatchCenter',
      path: 'dispatchCenter',
      name: 'dispatchCenter',
      component: 'main/dispatchCenter',
      meta: {
        title: '调度中心'
      }
    },
    {
      key: 'Intelligent.PriceAnalysis',
      path: 'priceAnalysis',
      name: 'priceAnalysis',
      component: 'main/priceAnalysis',
      meta: {
        title: '价格带分析'
      }
    },
    {
      key: 'Intelligent.TimeSaleAnalysis',
      path: 'timeSaleAnalysis',
      name: 'timeSaleAnalysis',
      component: 'main/timeSaleAnalysis',
      meta: {
        title: '时间段分析'
      }
    },
    {
      key: 'Intelligent.PassengerFlow',
      path: 'passflowAnalysis',
      name: 'passflowAnalysis',
      component: 'main/passflowAnalysis',
      meta: {
        title: '人脸客流分析'
      }
    }
  ]
}

export default common



// WEBPACK FOOTER //
// ./src/libs/common.js